import React, { useEffect, useState, useContext } from "react";
import ListContainer from "../components/ListContainer/ListContainer";
import PostContainer from "../components/PostContainer/PostContainer";
import { useAuthContext } from "../Hooks/useAuthContext";
import "../index.css";
import { useTickerContext } from "../Hooks/useTickerContext";
import { SearchTickerContext } from "../Context/SearchTickerContext";
import ScrollToTopButton from "../components/Button/ScrollToTopButton";
import PodcastLibrary from "../podcast/PodcastLibrary";
import { Card, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import SearchResult from "../components/Search/SearchResult/SearchResult";
import { Helmet } from "react-helmet-async";
const Home = () => {
  const { user } = useAuthContext();
  const { tickers, dispatch } = useTickerContext();
  const [error, setError] = useState(null);
  const { handleTickerClick, handleTickerInput, value, setValue, searchResults, setSearchResults } = useContext(SearchTickerContext);
  const clearSearch = () => { setValue(""); setSearchResults([]); };
  // get all the new update ticker
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/api/ticker/`);
        if (response.ok) {
          const json = await response.json();
          dispatch({ type: "FETCH_TICKER", payload: json });
        } else {
          throw new Error("Failed to fetch tickers");
        }
      } catch (error) {
        setError(error.message);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>We Win Together</title>
        <meta
          name="description"
          content="Stay updated with the market calendar, breaking news, and trading education. We Win Together provides valuable insights for successful trading."
        />
        <meta
          name="keywords"
          content="market calendar, trading events, breaking news, insights"
        />
        <meta name="author" content="We Win Together" />
      </Helmet>
      <main className="tradinghub-home">
        <label className="home-ticker-search">
          <Icon name="search" />
          <input
            type="search"
            aria-label="Tìm kiếm ticker"
            placeholder="Tìm kiếm ticker…"
            value={value}
            onChange={handleTickerInput}
          />
          {value && <button type="button" onClick={clearSearch} aria-label="Xóa tìm kiếm"><Icon name="close" /></button>}
        </label>
        {!user && value && <p><Link to="/login">Đăng nhập để xem chi tiết ticker</Link></p>}
        {error && <div className="market-error">{error}</div>}

        {tickers && tickers.length > 0 && (
          <section className="symbol-strip" aria-label="Community ticker list">
            {tickers.map((ticker) => (
              <button
                className="symbol-pill"
                key={ticker._id}
                type="button"
                onClick={() =>
                  handleTickerClick(ticker.ticker)
                }
              >
                {ticker.ticker}
              </button>
            ))}
          </section>
        )}

        {(searchResults.tickerData?.length > 0 || searchResults.breakingNewData?.length > 0) && (
          <section className="home-ticker-results" aria-label="Kết quả tìm kiếm ticker">
            <div className="home-ticker-results__heading">
              <h2>Kết quả tìm kiếm</h2>
              <button type="button" onClick={clearSearch}>Đóng kết quả <Icon name="close" /></button>
            </div>
            <Card.Group centered>
              {(searchResults.tickerData || []).map((ticker) => <SearchResult key={ticker._id} tickerResult={ticker} handleClear={clearSearch} />)}
            </Card.Group>
            {(searchResults.breakingNewData || []).map((news) => <SearchResult key={news._id} breakingNewResult={news} />)}
          </section>
        )}

        <PodcastLibrary isHomepage />

        <div className="Home" id="market-feed">
          <ListContainer />
          <PostContainer />
        </div>

        <ScrollToTopButton />
      </main>
    </>
  );
};

export default Home;
